import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b226c65e")

_pushScopeId("data-v-b226c65e")
const _hoisted_1 = {
  key: 0,
  class: "form-simulation-contact"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "item-name" }
const _hoisted_5 = { class: "item-value" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { value: 0 }
const _hoisted_8 = { class: "buttons-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_table_tax = _resolveComponent("table-tax")

  return ($setup.simulationForm)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("dig-input-text", {
          id: "firstname",
          value: $setup.simulationForm.firstname,
          onInput: _cache[1] || (_cache[1] = ($event: any) => ($setup.updateField('firstname', $event.target.value))),
          required: ""
        }, _toDisplayString($setup.t('Simulation.firstname')), 41, ["value"]),
        _createVNode("dig-input-text", {
          id: "lastname",
          value: $setup.simulationForm.lastname,
          onInput: _cache[2] || (_cache[2] = ($event: any) => ($setup.updateField('lastname', $event.target.value))),
          required: ""
        }, _toDisplayString($setup.t('Simulation.lastname')), 41, ["value"]),
        _createVNode("dig-input-text", {
          id: "address",
          value: $setup.simulationForm.address,
          onInput: _cache[3] || (_cache[3] = ($event: any) => ($setup.updateField('address', $event.target.value))),
          required: ""
        }, _toDisplayString($setup.t('Simulation.address')), 41, ["value"]),
        _createVNode("dig-input-text", {
          id: "cp",
          value: $setup.simulationForm.cp,
          onInput: _cache[4] || (_cache[4] = ($event: any) => ($setup.updateField('cp', $event.target.value))),
          required: ""
        }, _toDisplayString($setup.t('Simulation.cp')), 41, ["value"]),
        _createVNode("dig-input-text", {
          id: "city",
          value: $setup.simulationForm.city,
          onInput: _cache[5] || (_cache[5] = ($event: any) => ($setup.updateField('city', $event.target.value))),
          required: ""
        }, _toDisplayString($setup.t('Simulation.city')), 41, ["value"]),
        _createVNode("dig-input-text", {
          id: "email",
          value: $setup.simulationForm.email,
          onInput: _cache[6] || (_cache[6] = ($event: any) => ($setup.updateField('email', $event.target.value))),
          required: "",
          type: "email"
        }, _toDisplayString($setup.t('Simulation.email')), 41, ["value"]),
        _createVNode("dig-input-phone", {
          id: "phone",
          value: $setup.simulationForm.phone,
          onInput: _cache[7] || (_cache[7] = ($event: any) => ($setup.updateField('phone', $event.target.value))),
          required: ""
        }, _toDisplayString($setup.t('Simulation.phone')), 41, ["value"]),
        _createVNode("dig-input-radio-wrapper", {
          value: $setup.simulationForm.ownerType,
          onInput: _cache[8] || (_cache[8] = ($event: any) => ($setup.updateField('ownerType', $event.detail))),
          required: "",
          title: "Situation"
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.ALL_OWNER_TYPES, (ownerType) => {
            return (_openBlock(), _createBlock("dig-input-radio", {
              key: ownerType,
              value: ownerType
            }, _toDisplayString($setup.t(`Simulation.OwnerType.${ownerType}`)), 9, ["value"]))
          }), 128))
        ], 40, ["value"]),
        _hoisted_2,
        _createVNode("dig-input-radio-wrapper", {
          value: $setup.simulationForm.powerType,
          onInput: _cache[9] || (_cache[9] = ($event: any) => ($setup.updateField('powerType', $event.detail))),
          required: "",
          title: $setup.t('Simulation.powerType')
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.ALL_POWER_TYPES, (powerType) => {
            return (_openBlock(), _createBlock("dig-input-radio", {
              key: powerType,
              value: powerType
            }, _toDisplayString($setup.t(`Simulation.PowerType.${powerType}`)), 9, ["value"]))
          }), 128))
        ], 40, ["value", "title"]),
        _createVNode("dig-input-checkbox", {
          id: "noAuto",
          checked: $setup.simulationForm.noAuto,
          onChange: _cache[10] || (_cache[10] = ($event: any) => ($setup.updateField('noAuto', $event.detail)))
        }, _toDisplayString($setup.t('dontWantToSayIncomes')), 41, ["checked"]),
        (!$setup.simulationForm.noAuto)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode("dig-input-number", {
                id: "incomes",
                value: $setup.simulationForm.incomes,
                onInput: _cache[11] || (_cache[11] = ($event: any) => ($setup.updateField('incomes', $event.target.value))),
                suffix: "€"
              }, _toDisplayString($setup.t('Simulation.incomes')), 41, ["value"]),
              _createVNode("dig-input-number", {
                id: "person",
                value: $setup.simulationForm.person,
                onInput: _cache[12] || (_cache[12] = ($event: any) => ($setup.updateField('person', $event.target.value))),
                suffix: "Personnes",
                pattern: "[0-9]*"
              }, _toDisplayString($setup.t('Simulation.person')), 41, ["value"]),
              _createVNode("p", null, [
                _createVNode("span", _hoisted_4, _toDisplayString($setup.t('Simulation.taxBracket')) + " : ", 1),
                _createVNode("span", _hoisted_5, _toDisplayString($setup.t(`Simulation.TaxBracket.${$props.simulation?.taxBracket || null}`)), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        ($setup.simulationForm.noAuto)
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode(_component_table_tax, {
                cp: $setup.simulationForm.cp
              }, null, 8, ["cp"]),
              _createVNode("dig-input-select-picker", {
                value: $setup.simulationForm.taxBracket,
                onSelect: _cache[13] || (_cache[13] = ($event: any) => ($setup.updateField('taxBracket', $event.detail))),
                label: $setup.t('Simulation.taxBracket')
              }, [
                _createVNode("dig-input-select-picker-option", _hoisted_7, _toDisplayString($setup.t(`Simulation.TaxBracket.undefined`)), 1),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.ALL_TAX_BRACKETS, (taxBracket) => {
                  return (_openBlock(), _createBlock("dig-input-select-picker-option", {
                    key: taxBracket,
                    value: taxBracket,
                    class: {
            'very-low': taxBracket === $setup.TaxBracket.VERY_LOW,
            low: taxBracket === $setup.TaxBracket.LOW,
            medium: taxBracket === $setup.TaxBracket.MEDIUM,
            high: taxBracket === $setup.TaxBracket.HIGH,
          }
                  }, _toDisplayString($setup.t(`Simulation.TaxBracket.${taxBracket}`)), 11, ["value"]))
                }), 128))
              ], 40, ["value", "label"])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_8, [
          _createVNode("dig-ui-standard-button", {
            onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.reset()))
          }, _toDisplayString($setup.t('reinit')), 1)
        ])
      ]))
    : _createCommentVNode("", true)
})